import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import routes from '@routes';
import { Page } from '@common/ui/Page';
import PersonalTokensTable from '@PersonalApiTokens/organisms/PersonalTokensTable';

export default function PersonalApiTokensPage() {
  return (
    <Page
      title="Personal API Tokens"
      button={
        <Button
          variant="contained"
          component={Link}
          to={routes.AddPersonalApiToken.path}
          data-testid={'add-api-token-button'}
        >
          Add API Token
        </Button>
      }
    >
      <PersonalTokensTable />
    </Page>
  );
}
